<template>
  <div>
    <div class="headCont">
      <div class="addBoxs">
        <div class="addBox dis-cent" @click="addClick">
          <div class="iconfont icon-add"></div>
          <div class="text">发布零工</div>
        </div>
        <div class="gxBox" @click="shuaxinClick">
          <div class="text">更新岗位后没变化？点击刷新</div>
        </div>
      </div>
      <div class="slelectCont">
        <div class="ssBox">
          <input
            type="text"
            placeholder="搜索"
            v-model="searChTxt"
            @keyup.enter="searchClick"
          />
          <div
            class="iconfont icon-search search dis-cent"
            @click="searchClick"
          ></div>
        </div>
        <!-- <div class="lxBox dis-cent">
          <div class="name">全部职位类型</div>
          <div class="iconfont icon-unfold unfold"></div>
        </div> -->
      </div>
    </div>
    <div class="typeList">
      <div
        class="type"
        v-for="(item, index) in typeList"
        :class="item.id == typeOn ? 'on' : ''"
        @click="typeClick(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="content">
      <Kong v-if="list.length == 0" />
      <div
        class="contBox"
        v-for="(item, index) in list"
        :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
      >
        <div class="txtCont">
          <div class="name">{{ item.name }}</div>
          <div class="textBox">
            <div class="txt">{{ item.district_cn }}</div>
            <div class="shu"></div>
            <div class="txt">
              {{ item.price }}元/{{ item.way == 1 ? "件" : item.way == 2 ? "小时" : item.way == 3 ? "天" : "月" }}
            </div>
            <div class="shu"></div>
            <div class="txt">
              {{
                item.result == 1 ? "日结" : item.result == 2 ? "周结" : "月结"
              }}
            </div>
          </div>
        </div>
        <div class="lxCont">
          <div class="box">
            <div
              class="num"
              :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
            >
              <span>{{
                item.readresumeslength ? item.readresumeslength : 0
              }}</span
              >/{{ item.resumeslength }}
            </div>
            <div
              class="name"
              :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
            >
              投递简历
            </div>
          </div>
          <div class="box">
            <div
              class="num"
              :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
            >
              {{ item.chatlength }}
            </div>
            <div
              class="name"
              :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
            >
              沟通人数
            </div>
          </div>
          <div class="box">
            <div
              class="num"
              :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
            >
              {{ item.favoritelength }}
            </div>
            <div
              class="name"
              :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
            >
              浏览人数
            </div>
          </div>
          <div class="box">
            <div
              class="num"
              :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
            >
              {{ item.favoritelength }}
            </div>
            <div
              class="name"
              :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
            >
              收藏人数
            </div>
          </div>
        </div>
        <div class="zhuangtai">
          <div
            class="yuan"
            :class="item.display == 2 || item.audit == 3 ? 'huiyuan' : ''"
          ></div>
          <div class="name">
            {{ item.display == 1 ? "开放中" : "待开放" }}
          </div>
        </div>
        <div class="funCont">
          <div class="box">
            <div class="text" @click="bjClick(item.id)">编辑</div>
            <div class="text" @click="kfClick(item.id, item.display, index)">
              {{
                item.audit == 3
                  ? "审核失败"
                  : item.display == 1
                  ? "关闭职位"
                  : "开放职位"
              }}
            </div>
          </div>
          <div class="cont">
            <!-- <div class="txt" v-if="item.time>0">剩余时间：{{item.time}}小时</div>
            <div class="txt" v-if="item.time<=0">已过期，自动下线</div>
            <div class="shu"></div> -->
            <div class="txt">
              <a-popconfirm
                title="是否确定删除"
                ok-text="是"
                cancel-text="否"
                @confirm="delClick(item.id)"
              >
                删除
              </a-popconfirm>
            </div>
          </div>
          <!-- <div class="iconfont icon-more more"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Kong from "../../component/kong.vue";
import { Popconfirm, Modal } from "ant-design-vue";

export default {
  components: {
    Kong,
    "a-popconfirm": Popconfirm,
    "a-modal": Modal,
  },
  name: "",
  data() {
    return {
      typeOn: 0,
      typeList: [
        {
          id: 0,
          name: "全部职位",
        },
        {
          id: 1,
          name: "开放中",
        },
        {
          id: 2,
          name: "待开放",
        },
        {
          id: 3,
          name: "审核失败",
        },
      ],
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      list: [],
      totalCount: 0,
      searChTxt: "",
    };
  },
  created() {
    this.listGet();
  },
  methods: {
    delClick(id) {
      console.log(id);
      this.$post("/common/delete", {
        id,
        table: "odd_job",
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.page.pageNo = 1;
          this.totalCount = 0;
          this.listGet();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    typeClick(id) {
      this.typeOn = id;
      if (id == 0) {
        this.page.display = "";
        this.page.audit = "";
      }
      if (id == 1 || id == 2) {
        this.page.display = id;
        this.page.audit = "";
      }
      if (id == 3) {
        this.page.display = "";
        this.page.audit = id;
      }
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    bjClick(id) {
      // this.$router.push({
      //   path: "/gongsi/addZhiwei",
      //   query: {
      //     type: 1,
      //     id,
      //   },
      // });
      window.open("#/gongsi/addZhiwei?type=1&id=" + id);
    },
    kfClick(id, dis, i) {
      let display;
      if (dis == 1) {
        display = 2;
      } else if (dis == 2) {
        display = 1;
      }
      this.$post("/nozzle/web/company_odd_display", {
        id,
        display,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.list[i].display = display;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/company_odd", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.time = this.timeXcGet(e.end_time);
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    timeXcGet(time) {
      const now = this.$moment();
      let jptime = this.$moment(time * 1000).format();
      jptime = this.$moment(jptime);
      jptime = this.$moment.duration(jptime.diff(now));
      return jptime.asHours().toFixed(1);
    },
    searchClick() {
      this.page.name = this.searChTxt;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    shuaxinClick(){
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    addClick() {
      // this.$router.push({
      //   path: "/gongsi/addZhiwei",
      //   query: {
      //     type: 1,
      //   },
      // });
      window.open("#/gongsi/addZhiwei?type=1");
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.headCont {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  margin-top: 10px;
  .addBoxs{
    display: flex;
    align-items: center;
  }
  .addBox {
    display: flex;
    align-items: center;
    height: 35px;
    width: 110px;
    border-radius: 5px;
    background-color: #1a78ec;
    color: #fff;
    padding-right: 5px;
    cursor: pointer;
    .icon-add {
      font-weight: 600;
    }
    .text {
      margin-left: 5px;
    }
  }
  .gxBox{
    display: flex;
    align-items: center;
    height: 35px;
    border-radius: 5px;
    background-color: #e70b0b;
    color: #fff;
    padding: 0 15px;
    cursor: pointer;
    margin-left: 15px;
  }
  .slelectCont {
    display: flex;
    align-items: center;
    .ssBox {
      height: 35px;
      background-color: #fff;
      width: 260px;
      border-radius: 5px;
      display: flex;
      input {
        width: calc(100% - 35px);
        box-sizing: border-box;
        padding-left: 15px;
      }
      .search {
        width: 35px;
        height: 35px;
        color: #9c9c9c;
        font-size: 18px;
      }
    }
    .lxBox {
      margin-left: 20px;
      height: 35px;
      width: 140px;
      background-color: #fff;
      border-radius: 5px;
      cursor: pointer;
      color: #666;
      .unfold {
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
}
.typeList {
  height: 50px;
  align-items: center;
  width: 100%;
  margin: auto;
  display: flex;
  .type {
    padding: 3px 15px;
    cursor: pointer;
    border-radius: 5px;
  }
  .on {
    background-color: #e1ecfa;
    color: #1a78ec;
    font-weight: 600;
  }
}
.content {
  width: 100%;
  margin: auto;
  margin-top: 8px;
  .contBox {
    border-radius: 10px;
    background-color: #fff;
    padding: 20px 40px;
    display: flex;
    margin-bottom: 15px;
    align-items: center;
    .txtCont {
      width: 320px;
      height: 55px;
      .name {
        font-size: 16px;
      }
      .textBox {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #9c9c9c;
        margin-top: 10px;
        .shu {
          width: 1px;
          height: 12px;
          background-color: #e0e0e0;
          margin: 0 10px;
        }
      }
    }
    .lxCont {
      width: 330px;
      display: flex;
      align-items: center;
      .box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        margin-right: 25px;
        .num {
          color: #000;
          font-size: 16px;
          margin-bottom: 6px;
          span {
            font-weight: 600;
            color: #1a78ec;
          }
        }
        .name {
          font-size: 12px;
          color: #5d6674;
        }
      }
    }
    .zhuangtai {
      display: flex;
      align-items: center;
      width: 70px;
      .yuan {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #1a78ec;
        margin-right: 5px;
      }
    }
    .funCont {
      width: calc(100% - 70px - 330px - 320px);
      .box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .text {
          margin-left: 20px;
          color: #1a78ec;
          cursor: pointer;
        }
        .textBox {
          background-color: #1a78ec;
          color: #fff;
          padding: 3px 6px 3px 8px;
          border-radius: 5px;
          cursor: pointer;
        }
        .more {
          font-size: 24px;
          color: #9c9c9c;
          cursor: pointer;
        }
      }
      .cont {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 13px;
        color: #777;
        padding-top: 3px;
        .shu {
          margin: 0 10px;
          width: 1px;
          height: 14px;
          background-color: #70757c;
        }
        .txt {
          cursor: pointer;
        }
      }
    }
  }
  .hui {
    color: #9c9c9c !important;
  }
  .huiyuan {
    background-color: #9c9c9c !important;
  }
}
</style>
